jQuery(document).ready(function () {
  var $lcs = jQuery('#content > *:visible:last');

  if ($lcs.hasClass('bg-black')) {
    $lcs.addClass('lcs');
  }
});